import React, { useRef } from 'react';
import styles from './style.module.scss';
import { Button, Checkbox, MenuItem, Grid, FormControlLabel } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { OverlayTrigger, Popover } from "react-bootstrap";
import { Category, ProdStatus } from './constant';
import { useOutsideClick } from '../../components/OutsideClick/handleOutsideClick';
import { capitalizeOnlyFirstLetter } from '../../utils/commonFunctions';

const OrderFilterComponent = ({
    enableUpdatePrice = false,
    ...props}) => {

    const overlayStatus = useRef(null);
    const overlayCategory = useRef(null);
    const overlayBrand = useRef(null);

    //Popover component
    const popover = (list, type) => (
        <Popover id="popover-basic" >
            <Popover.Content id={styles.popContent}>
                <div className={styles.popoverBody}>
                    {type !== 'status' &&
                        <div >
                            {list && list.length > 0 && list.map((name, index) => (
                                <div className={`d-flex ${styles.filterList}`} key={index}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={getStatuChecked(type, type === 'brand' ? name.brand : type === 'category' ? capitalizeOnlyFirstLetter(name.name) : name.value)}
                                                onChange={(e) => props.filterChange(e, type)}
                                                name={type === 'brand' ? name.brand : type === 'category' ? capitalizeOnlyFirstLetter(name.name) : name.label}
                                                color="primary"
                                                className={styles.checkboxList}
                                                value={type === 'brand' ? name.brand : type === 'category' ? capitalizeOnlyFirstLetter(name.name)  : name.value}
                                            />
                                        }
                                        label={type === 'brand' ? name.brand : type === 'category' ? capitalizeOnlyFirstLetter(name.name) : name.label}
                                    />
                                </div>
                            ))}
                            {
                                list.length === 0 && type === 'brand' ? <div>No brands found for the selected categories.</div> : null
                            }
                        </div>
                    }
                    {type === 'status' &&
                        list.map((name, index) => (
                            <div key={index}>
                                <MenuItem name={name.label} value={name.value} onClick={(e) => props.filterChange(e, type)}>{name.label}</MenuItem>
                            </div>
                        ))}
                </div>
                {
                    type !== 'status' && type !== 'inventoryRequestBrand' && list && list.length > 0 ?
                        <div className="d-flex justify-content-center align-items-center pt-4 pl-2 pr-2">
                            <Button variant="contained" className="greyBtn" disableElevation onClick={() => props.cancelFilters(type)}>
                                Cancel
                            </Button>
                            <Button variant="contained" className="mainBtn ml-2" disableElevation onClick={() => props.applyFilter(type)}>
                                Apply
                            </Button>
                        </div>
                        : null
                }
            </Popover.Content>
        </Popover>
    );

    //function to handle popover ref
    const getRef = () => {
        if (props.showFilters.status)
            return overlayStatus
        else if (props.showFilters.category)
            return overlayCategory
        else if (props.showFilters.brand)
            return overlayBrand
    }

    //function to handle filters 
    const getStatuChecked = (type, val) => {
        if (type === 'status') {
            return props.selectedFilters.status.includes(val) ? true : false;
        }
        else if (type === 'category') {
            return props.selectedFilters.category.includes(val) ? true : false;
        }
        else if (type === 'brand') {
            return props.selectedFilters.brand.includes(val) ? true : false;
        }
    }

    //function to handle outside click
    useOutsideClick(getRef(), () => {
        let obj;
        if (props.showFilters.status)
            obj = 'status';
        else if (props.showFilters.category)
            obj = 'category';
        else if (props.showFilters.brand)
            obj = 'brand';
        props.cancelFilters(obj)
    });

    return <div className={styles.filterComp}>
        <Grid container alignItems="center" spacing={0}>
            <Grid container md={9} alignItems="center" spacing={3}>
                <Grid item md={3} >
                    <div className="input-group" >
                        <input type="text" name="searchOrderId" autoComplete="off" className={`${!props.modelSearch ? styles.defaultInput : ''} ${styles.searchInput} form-control`} placeholder="Search by Model ID" aria-describedby="basic-addon2" value={props.modelSearch || ''} onChange={(e) => props.handleSearchChange(e)} />
                        {props.modelSearch ?
                            <span className={`${!props.modelSearch ? styles.defaultInput : ''} ${styles.clearBtn} input-group-text`} id="basic-addon2" onClick={() => props.handleSearchChange(null, 'clear')}> <ClearIcon style={{ color: 'grey' }} /></span>
                            : null}
                        <span className={`${props.modelSearch ? styles.defaultSearch : ''} ${styles.searchBtn} input-group-text`} id="basic-addon2" onClick={(e) => props.modelSearch ? props.searchExactModelID(props.modelSearch) : null}> <SearchIcon /></span>
                    </div>
                </Grid>
                <span>Filters:</span>
                <Grid item auto="true" >
                    <div ref={overlayStatus}>
                        <OverlayTrigger container={overlayStatus.current} trigger="click" placement="right" show={props.showFilters.status} overlay={popover(ProdStatus, 'status')} >
                            <Button variant="contained" className={styles.dateBtn} disableElevation onClick={() => props.showFiltersFnc('status')}>
                                Product Status
                                <span className="pl-2 d-flex align-items-end">  <ExpandMoreIcon fontSize="small" /></span>
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Grid>
                <Grid item auto="true" >
                    <div ref={overlayCategory}>
                        <OverlayTrigger container={overlayCategory.current} trigger="click" placement="right" show={props.showFilters.category} overlay={popover(props.categoryList, 'category')} >
                            <Button variant="contained" className={styles.dateBtn} disableElevation onClick={() => props.showFiltersFnc('category')}>
                                Category
                                <span className="pl-2 d-flex align-items-end">  <ExpandMoreIcon fontSize="small" /></span>
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Grid>
                <Grid item auto="true">
                    <div ref={overlayBrand}>
                        <OverlayTrigger container={overlayBrand.current} trigger="click" placement="right" show={props.showFilters.brand} overlay={popover(props.brandData, 'brand')} >
                            <Button variant="contained" className={styles.dateBtn} disableElevation onClick={() => props.showFiltersFnc('brand')}>
                                Brand
                                <span className="pl-2 d-flex align-items-end">  <ExpandMoreIcon fontSize="small" /></span>
                            </Button>
                        </OverlayTrigger>
                    </div>
                </Grid>
            </Grid>
            <Grid container md={3} alignItems="center" justifycontent="flex-end" spacing={3}>
                <Grid item md={12}>
                    <div className={styles.extraBtnContainer}>
                        <Button variant="outlined" className={styles.addInv} color="primary" onClick={() => props.updatePrice()} disabled={!enableUpdatePrice} >
                            Update&nbsp;Price
                        </Button>

                        <Button variant="contained" className={styles.addInv} color="primary" onClick={() => props.setShowCatalogueModal()}>
                            Add&nbsp;Inventory
                        </Button>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    </div>
}

const FiltersComponent = React.memo(OrderFilterComponent);

export default FiltersComponent;
